import { http } from '../../../api/axios';
import { appConfig } from '../../../config';

export const neverShowReserveReportVideoAgain = () => {
    return http.put<void>(appConfig().endpointTutorial, { showReserveVideo: false });
};
